import { render, staticRenderFns } from "./PremiumLoader.vue?vue&type=template&id=2bc41c07&scoped=true"
import script from "./PremiumLoader.vue?vue&type=script&lang=js"
export * from "./PremiumLoader.vue?vue&type=script&lang=js"
import style0 from "./PremiumLoader.vue?vue&type=style&index=0&id=2bc41c07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc41c07",
  null
  
)

export default component.exports